import { Button as SemanticButton } from "semantic-ui-react";
import styled from "styled-components";

export const Button = styled(SemanticButton)`
  background-color: #d1d1d1;
`;
